import { render } from "./detailXy.vue?vue&type=template&id=109c6b2c"
import script from "./detailXy.vue?vue&type=script&lang=js"
export * from "./detailXy.vue?vue&type=script&lang=js"

import "./detailXy.vue?vue&type=style&index=0&id=109c6b2c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__